import React, { useEffect, useMemo, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";
import { useTable, usePagination, useSortBy } from "react-table";
import Cookie from "universal-cookie";
import MiniGrafico from "./MiniGrafico";

function IndicadorApoyo(props) {
  const cookie = new Cookie();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [selectedOptions1, setSelectedOptions1] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [list1, setList1] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtieneListadoIndicadores",
    })
      .then((Response) => {
        const apiOptions1 = Response.data
          .filter((item) => item.origen === "A10")
          .map((item) => ({
            value: item.codigo,
            label: `${item.nombreIndicador} - Código: ${item.codigo}`,
            grupo: item.origen,
          }));
        setOptions1(apiOptions1);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const postData = (e) => {
    e.preventDefault();
    selectedOptions1.forEach((option) => {
      axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://suadesarrollo.azurewebsites.net/api/PriorizaIndicadoresA/${props.solicitudId}/${option.value}/${option.grupo}`,
      })
        .then((Response) => {
          alert(Response.data);
        })
        .catch((error) => {
          console.log(error);
          alert("Error al crear: " + error);
        });
    });
  };

  useEffect(() => {
    const fetchData = () => {
      axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://suadesarrollo.azurewebsites.net/api/ObtenerPriorizados/${props.solicitudId}`,
      })
        .then((response) => {
          setList1(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchData();
    const intervalId = setInterval(fetchData, 5000);
    return () => clearInterval(intervalId);
  }, [props.solicitudId]);

  const columns = useMemo(
    () => [
      {
        Header: "Código",
        accessor: "codigo",
      },
      {
        Header: "Nombre Indicador",
        accessor: "nombreIndicador",
      },
      {
        Header: "Grupo",
        accessor: "grupo",
      },
    ],
    [],
  );

  const data = useMemo(() => list1.filter((e) => e.grupo === "A10"), [list1]);
  const tableInstance = useTable({ columns, data }, useSortBy, usePagination);
  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    tableInstance;

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Priorizar indicadores
          </h6>
          <div className="col-sm-12">Seleccione el indicador</div>
          <Select
            name="indicators"
            options={options1}
            classNamePrefix="select"
            isMulti
            onChange={(selected) => setSelectedOptions1(selected)}
          />
          <MiniGrafico solicitud={props.solicitudId} />
        </div>
        <div className="card-body">
          <button
            className="btn btn-primary btn-user btn-block"
            onClick={postData}
          >
            Priorizar
          </button>
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-bordered">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps(),
                        )}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndicadorApoyo;
